import {
    GET_COMPANIES_REQUEST,
    GET_COMPANIES_SUCCESS,
    GET_COMPANIES_FAILURE,
    SUBMIT_COMPANY_REQUEST,
    SUBMIT_COMPANY_SUCCESS,
    SUBMIT_COMPANY_FAILURE,
    SET_COMPANIES,
    SET_COMPANY,
    GET_COMPANY_REQUEST,
    GET_COMPANY_SUCCESS,
    GET_COMPANY_FAILURE,
    TEST_EMAIL_REQUEST,
    TEST_EMAIL_SUCCESS,
    TEST_EMAIL_FAILURE,
    GET_PLANS_REQUEST,
    GET_PLANS_SUCCESS,
    GET_PLANS_FAILURE,
    GET_COMPANY_PLANS_REQUEST,
    GET_COMPANY_PLANS_SUCCESS,
    GET_COMPANY_PLANS_FAILURE
} from "../actions/company";
import { buildCompanies, buildCompany } from '../helpers/company';

const initialState = {
    fetching: false,
    companies: [],
    company: {},
    submitFetching: false,
    submitSuccess: false,
    testFetching: false,
    plansFetching: false,
    plans: [],
    companyPlansFetching:false,
    companyPlans:[]
};

export default (state = initialState, action) => {
    switch (action.type) {
        case TEST_EMAIL_REQUEST: {
            return{
                ...state,
                testFetching:true
            }
        }
        case TEST_EMAIL_SUCCESS: {
            return {
                ...state,
                testFetching:false
            }
        }
        case TEST_EMAIL_FAILURE: {
            return {
                ...state,
                testFetching:false
            }
        }
        case GET_COMPANIES_REQUEST: {
            return {
                ...state,
                fetching: true,
                submitSuccess: false,
            };
        }
        case GET_COMPANIES_SUCCESS: {
            return {
                ...state,
                fetching: false,
                companies: action.payload.companies ? buildCompanies(action.payload.companies) : state.companies
            };
        }
        case GET_COMPANIES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }

        case GET_PLANS_REQUEST: {
            return {
                ...state,
                plansFetching: true
            };
        }
        case GET_PLANS_SUCCESS: {
            return {
                ...state,
                plansFetching: false,
                plans: action.payload
            };
        }
        case GET_PLANS_FAILURE: {
            return {
                ...state,
                plansFetching: false
            };
        }
        case GET_COMPANY_PLANS_REQUEST:{
            return{
                ...state,
                companyPlansFetching:true
            };
        }
        case GET_COMPANY_PLANS_SUCCESS:{
            return{
                ...state,
                companyPlansFetching:false,
                companyPlans: action.payload,

            };
        }
        case GET_COMPANY_PLANS_FAILURE:{
            return{
                ...state,
                companyPlansFetching:false
            };
        }
        case GET_COMPANY_REQUEST: {
            return {
                ...state,
                fetching: true,
                company: {}
            };
        }
        case GET_COMPANY_SUCCESS: {
            return {
                ...state,
                fetching: false,
                company: buildCompany(action.payload.company)
            };
        }
        case GET_COMPANY_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }

        case SUBMIT_COMPANY_REQUEST: {
            return {
                ...state,
                submitFetching: true,
                submitSuccess: false
            };
        }
        case SUBMIT_COMPANY_SUCCESS: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: true
            };
        }
        case SUBMIT_COMPANY_FAILURE: {
            return {
                ...state,
                submitFetching: false,
                submitSuccess: false
            };
        }
        case SET_COMPANIES: {
            return {
                ...state,
                companies: action.payload.companies
            };
        }
        case SET_COMPANY: {
            return {
                ...state,
                company: action.payload.company
            };
        }
        default:
            return state;
    }
};
